import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from '../store/reducer/reducer';
import commonReducer from '../store/reducer/commonReducer';
import FileImportReducer from '../store/reducer/FileImportReducer';
import ProfileReducer from '../store/reducer/ProfileReducer';
import formBuilderReducer from '../store/reducer/formBuilderReducer';
import GridFilterReducer from '../store/reducer/GridFilterReducer';
import ReportReducer from '../store/reducer/ReportReducer';
import ShippingReducer from '../store/reducer/ShippingReducer';
import RateConfigReducer from '../store/reducer/RateConfigReducer';
import GridListReducer from '../store/reducer/GridListReducer';
import ApiClientReducer from './reducer/ApiClientReducer';
import StepsFlowReducer from './reducer/StepsFlowReducer';
import RateSheetReducer from './reducer/RateSheetReducer';
import ErrorSetupReducer from './reducer/ErrorSetupReducer';
import RatingsFlowReducer from './reducer/RatingsFlowReducer';
import RatingVariableReducer from './reducer/RatingVariableReducer';

const rootReducer = combineReducers({
  reducer : reducer,
  commonReducer : commonReducer,
  FileImportReducer : FileImportReducer,
  ProfileReducer : ProfileReducer,
  formBuilder : formBuilderReducer,
  GridFilterReducer:GridFilterReducer,
  ReportReducer:ReportReducer,
  ShippingReducer:ShippingReducer,
  RateConfigReducer:RateConfigReducer,
  GridListReducer:GridListReducer,
  ApiClientReducer:ApiClientReducer,
  StepsFlowReducer:StepsFlowReducer,
  RatingsFlowReducer:RatingsFlowReducer,
  RateSheetReducer:RateSheetReducer,
  ErrorSetupReducer:ErrorSetupReducer,
  RatingVariableReducer:RatingVariableReducer

});
const store = createStore(rootReducer, applyMiddleware(thunk));
export default store;
